import { TableCell, TableRow } from "@mui/material";

import ProviderHoursEditCell from "./ProviderHoursEditCell";
import ProviderHoursViewCell from "./ProviderHoursViewCell";


export default function ProviderHoursRow({ row, index, editor }) {
  const {
    editing,
    draftTimings,
    startEditing,
    stopEditing,
    updateTiming,
    addWindow,
    deleteWindow,
    saveTimings,
  } = editor;

  return (
    <TableRow>
      {!editing[index] ? (
        <ProviderHoursViewCell
          row={row}
          index={index}
          onEdit={startEditing}
        />
      ) : (
        <TableCell colSpan={3}>
          <ProviderHoursEditCell
            index={index}
            day={row.day}
            timings={draftTimings[index] || []}
            onChange={updateTiming}
            onAdd={addWindow}
            onDelete={deleteWindow}
            onSave={saveTimings}
            onDone={stopEditing}
          />
        </TableCell>
      )}
    </TableRow>
  );
}
